var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"jquery-ui-scope view bpms-Message"}),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }